"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEvents = void 0;
const i18n_1 = require("../../i18n");
const getEvents = (t) => [
    {
        title: t('SMART:CoverageSum.events.brokenNose', {
            defaultValue: i18n_1.i18nDefaultValues.CoverageSum.events.brokenNose,
        }),
        payments: '5%',
        amount: '25 000 ₽',
    },
    {
        title: t('SMART:CoverageSum.events.rightArm', {
            defaultValue: i18n_1.i18nDefaultValues.CoverageSum.events.rightArm,
        }),
        payments: '5%',
        amount: '25 000 ₽',
    },
    {
        title: t('SMART:CoverageSum.events.brain', {
            defaultValue: i18n_1.i18nDefaultValues.CoverageSum.events.brain,
        }),
        payments: '6%',
        amount: '30 000 ₽',
    },
    {
        title: t('SMART:CoverageSum.events.wrist', {
            defaultValue: i18n_1.i18nDefaultValues.CoverageSum.events.wrist,
        }),
        payments: '10%',
        amount: '50 000 ₽',
    },
    {
        title: t('SMART:CoverageSum.events.boneFracture', {
            defaultValue: i18n_1.i18nDefaultValues.CoverageSum.events.boneFracture,
        }),
        payments: '15%',
        amount: '75 000 ₽',
    },
    {
        title: t('SMART:CoverageSum.events.hipFracture', {
            defaultValue: i18n_1.i18nDefaultValues.CoverageSum.events.hipFracture,
        }),
        payments: '25%',
        amount: '125 000 ₽',
    },
    {
        title: t('SMART:CoverageSum.events.disability3', {
            defaultValue: i18n_1.i18nDefaultValues.CoverageSum.events.disability3,
        }),
        payments: '80%',
        amount: '400 000 ₽',
    },
    {
        title: t('SMART:CoverageSum.events.disability2', {
            defaultValue: i18n_1.i18nDefaultValues.CoverageSum.events.disability2,
        }),
        payments: '100%',
        amount: '500 000 ₽',
    },
];
exports.getEvents = getEvents;
